// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"filters_wrapper__3soaN","deleteAll":"filters_deleteAll__3D6XR","icon":"filters_icon__1Hmeo"};